import classNames from 'classnames';
import moment from 'moment';
import React from 'react';
import * as styles from './CommentTimestamp.module.scss';
import Button from '../../components/Button';
import Timestamp from '../../components/Timestamp';
import Tooltip from '../../components/Tooltip';
import type { Scalars } from '../../graphql/generated/graphql';

interface CommentTimestampProps {
  insertedAt: Scalars['Datetime']['output'];
  updatedAt: Scalars['Datetime']['output'];
  onClick?: () => void;
  noTooltip?: boolean;
}

const CommentTimestamp = ({
  insertedAt,
  updatedAt,
  onClick,
  noTooltip,
}: CommentTimestampProps) => {
  const isEdited = updatedAt && insertedAt !== updatedAt;

  const timestamp = (
    <>
      <Timestamp date={insertedAt} />
      {!!isEdited && ' (edited)'}
    </>
  );

  const content = (
    <>
      {onClick ? (
        <Button
          onClick={onClick}
          className={classNames(styles.timestamp, styles.timestampButton)}
        >
          {timestamp}
        </Button>
      ) : (
        <span className={styles.timestamp}>{timestamp}</span>
      )}
    </>
  );

  if (noTooltip) {
    return content;
  }

  return (
    <Tooltip
      content={
        <div className={styles.tooltip}>
          {isEdited ? (
            <>
              <div className={styles.labels}>
                <Tooltip.Muted>Created:</Tooltip.Muted>
                <Tooltip.Muted>Edited:</Tooltip.Muted>
              </div>
              <div className={styles.timestamps}>
                <span>{moment(insertedAt).format('MMM Do, YYYY, h:mm A')}</span>
                <span>{moment(updatedAt).format('MMM Do, YYYY, h:mm A')}</span>
              </div>
            </>
          ) : (
            moment(insertedAt).format('MMM Do, YYYY, h:mm A')
          )}
        </div>
      }
    >
      {content}
    </Tooltip>
  );
};

export default CommentTimestamp;
